import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["pageData", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Breadcrumbs, useMediaQuery, useTheme } from '@mui/material';
import { TAGLink, TAGTypography } from '../../elements';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

var TAGBreadCrumbs = function TAGBreadCrumbs(_ref) {
  var pageData = _ref.pageData,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var _pageData$breadcrumbs = pageData.breadcrumbs,
      breadcrumbs = _pageData$breadcrumbs === void 0 ? [] : _pageData$breadcrumbs,
      breadcrumbTitle = pageData.breadcrumbTitle;
  var theme = useTheme();
  var isSmall = useMediaQuery(theme.breakpoints.down('md'));
  var previousLevel = breadcrumbs[breadcrumbs.length - 1];
  var breadcrumbsRender = isSmall ? {
    breadcrumbTitle: null,
    breadcrumbsList: React.createElement(TAGLink, {
      href: previousLevel.path,
      variant: "lowestLevel",
      color: "text.link",
      sx: {
        display: 'flex',
        alignItems: 'center',
        height: '32px'
      }
    }, React.createElement(NavigateBeforeRoundedIcon, {
      fontSize: "small",
      sx: {
        color: 'text.secondary',
        mr: '5px'
      }
    }), previousLevel.breadcrumbTitle),
    separator: 'none'
  } : {
    breadcrumbTitle: breadcrumbTitle && React.createElement(TAGTypography, {
      variant: "bodySmallBook"
    }, breadcrumbTitle),
    breadcrumbsList: Array.isArray(breadcrumbs) && breadcrumbs.map(function (page, index) {
      return React.createElement(TAGLink, {
        key: "".concat(page.path, "-breadcrumb").concat(index),
        href: page.path,
        variant: "bodySmallBook",
        color: "text.link"
      }, page.breadcrumbTitle);
    }),
    separator: ''
  };
  return React.createElement(Breadcrumbs, _objectSpread(_objectSpread({}, props), {}, {
    separator: React.createElement(NavigateNextRoundedIcon, {
      fontSize: "small",
      sx: {
        display: breadcrumbsRender.separator
      }
    }),
    "aria-label": "breadcrumb",
    sx: sx
  }), breadcrumbsRender.breadcrumbsList, breadcrumbsRender.breadcrumbTitle);
};

export default TAGBreadCrumbs;